export const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? "http://localhost:8000";

export async function apiRequest<TResponse>(path: string, options?: RequestInit): Promise<TResponse> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...options?.headers
    }
  });

  const isLoginAttempt = path === "/auth/login";
  if (response.status === 401 && !isLoginAttempt && typeof window !== "undefined" && window.location.pathname !== "/login") {
    // A full page load on purpose: this runs outside React, where there is no router, and
    // it drops every page's in-memory state along with the expired session.
    // eslint-disable-next-line @next/next/no-location-assign-relative-destination
    window.location.href = "/login";
    // The redirect above is async; throwing keeps callers from acting on a body that
    // will never arrive.
    throw new Error("Not authenticated");
  }

  const body = response.status === 204 ? null : await response.json();

  if (!response.ok) {
    const message = body && typeof body.detail === "string" ? body.detail : "Request failed";
    throw new Error(message);
  }

  return body as TResponse;
}
